import React from "react";
import { Button, Modal } from "react-bootstrap";

import classNames from "classnames";

import { OrderModalProps } from "@LeagueManagement/Order/types/order";

const ReinstateOrderModal = ({
    show,
    handleClose,
    handleSubmit,
}: OrderModalProps): React.JSX.Element => (
    <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
            <Modal.Title className={classNames("text-center")}>
                Are you sure you want to reinstate this order?
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            Reinstating the order will:
            <ul>
                <li>
                    Restore <b>all</b> cancelled products on the order,
                    including registrations that were cancelled one at a time
                </li>
                <li>Update coupon usage (if applicable)</li>
                <li>Restore the order status from before the cancellation</li>
            </ul>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="primary" onClick={handleClose}>
                No
            </Button>
            <Button
                variant="success"
                onClick={() => handleSubmit("reinstateOrder", handleClose)}
            >
                Yes
            </Button>
        </Modal.Footer>
    </Modal>
);

export default ReinstateOrderModal;
